import React from 'react'
import styles from './LeftSidebar.module.css'

const SvgList    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
const SvgCheck   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>

const LeftSidebar = ({ activeTab, setActiveTab }) => {
    const menuItems = [
        { id: 'shortlist', label: 'Shortlist', icon: <SvgList /> },
        { id: 'actions',   label: 'Actions',   icon: <SvgCheck /> },
    ]

    return (
        <div className={styles.sidebar}>
            {menuItems.map((item) => (
                <button
                    key={item.id}
                    className={`${styles.menuItem} ${activeTab === item.id ? styles.active : ''}`}
                    onClick={() => setActiveTab(item.id)}
                >
                    <span className={styles.icon}>{item.icon}</span>
                    <span className={styles.label}>{item.label}</span>
                </button>
            ))}
        </div>
    )
}

export default LeftSidebar
